const handleSuccessResponse = response => {
  return Promise.resolve({
    response: response?.data?.data,
    errors: response?.data?.errors,
    status: response?.status,
  });
};

export default handleSuccessResponse;
